import { Link } from "react-router-dom"
import { useAtom } from "jotai"
import { isSuperAdminAtom, isGuideAtom, isGuideAdminAtom } from "../../state"

const QuickActions = () => {
  const [isSuperAdmin] = useAtom(isSuperAdminAtom)
  const [isGuideAdmin] = useAtom(isGuideAdminAtom);
  const [isGuide] = useAtom(isGuideAtom)

  let actions = [
    {
      label: "View Plans",
      icon: "fa-clipboard-list",
      to: "/admin/plans",
      color: "bg-brand",
    },
  ]

  if (isGuide || isGuideAdmin) {
    actions = [
      {
        label: "View My Plans",
        icon: "fa-compass",
        to: "/admin/plans",
        color: "bg-brand",
      },
    ]
  }
  if (!isGuide && !isGuideAdmin) {
    actions.push({
      label: "View Users",
      icon: "fa-users",
      to: "/admin/users",
      color: "bg-brand",
    })
  }

  // Add organizations link for super admins
  if (isSuperAdmin) {
    actions.unshift({
      label: "View Organizations",
      icon: "fa-building",
      to: "/admin/organizations",
      color: "bg-brandSecondary",
    })
  }

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h2 className="text-xl font-semibold text-gray-800 mb-4">Quick Actions</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {actions.map((action, index) => (
          <Link
            key={index}
            to={action.to}
            className={`flex items-center justify-center gap-2 ${action.color} hover:opacity-90 text-white font-semibold py-3 px-6 rounded-lg shadow-md transition-all duration-200`}
          >
            <i className={`fa ${action.icon}`}></i>
            {action.label}
          </Link>
        ))}
      </div>
    </div>
  )
}

export default QuickActions
